import React from 'react';
import { navigate } from 'gatsby-link';
import { useRecoilState, useResetRecoilState } from 'recoil';
import { Label } from '@nooz-optics/nooz-components-lib';
import { setToken } from '../../../../services/NoozApi';
import { UserState } from 'utils/recoil/user';
import { StickySidebar } from 'components/UI/Layout';
import { Component } from '../../../Contentful/component';
import { Link } from '../../../UI/Elements/Link';
import { returnLocalisedPath } from 'utils/globals';
import { withLocale } from 'utils/hocs';
import { Button } from '../../../UI/Elements';

export const UserDetailsAccountWithNav = withLocale(
  ({ list, links, myAccountLabel, logoutLabel, locale }) => {
    const [user, setUser] = useRecoilState(UserState);

    const resetUserState = useResetRecoilState(UserState);

    const handleLogoutClick = () => {
      resetUserState();
      window.localStorage.removeItem('userToken');
      setToken(undefined);
      navigate(returnLocalisedPath(locale[0], ''));
    };

    const returnAccountNav = () => (
      <div className='p-4 border bg-white'>
        <div className='mb-2'>
          <Label
            size='xl'
            weight='medium'
            text={myAccountLabel.text}
          />
        </div>
        <ul className='pl-4'>
          {links.items.map((link) => (
            <li className='hover:translate-x-2 py-2 flex justify-start transform transition ease-in-out'>
              <Link {...link} />
            </li>
          ))}
        </ul>
      </div>
    );

    const returnAccountContent = () => (
      <div>
        {list.items.map((item) => (
          <Component {...item} />
        ))}
      </div>
    );

    return (
      <div className='w-full'>
        <div className='w-full flex flex-col pt-6 pb-6 border-b lg:flex-row lg:justify-between lg:items-center lg:pb-24 lg:border-b-0'>
          <Label
            size='6xl'
            weight='medium'
            text={myAccountLabel.text}
          />
          <div className='pt-2 lg:pt-0'>
            <Button
              onClick={() => {
                handleLogoutClick();
              }}
              type='contained'
              color={{ classname: 'primary' }}
              label={{ text: logoutLabel.text }}
            />
          </div>
        </div>
        <div className='w-full'>
          <StickySidebar
            navChildren={returnAccountNav()}
            contentChildren={returnAccountContent()}
          />
        </div>
      </div>
    );
  }
);
